import { instance } from "api/apiBase";

export type OnboardingChecklistAttribution = {
  name: string;
};

export type OnboardingChecklistItem = {
  key: string;
  label: string;
  complete: boolean;
  cta_route: string;
  completed_at: string | null;
  completed_by: OnboardingChecklistAttribution | null;
};

export type OnboardingChecklistResponse = {
  completed_count: number;
  total_count: number;
  items: OnboardingChecklistItem[];
};

export const getOnboardingChecklist =
  async (): Promise<OnboardingChecklistResponse> =>
    (await instance.get(`/portal/v1/onboarding_checklist`)).data;
